// extracted by mini-css-extract-plugin
export default {"result":"OWV00B9ttySLdDP7toJ1"};